import { getIn } from 'formik';

import type { Field, FieldCondition } from '../types';

export const isFieldVisible = (field: Pick<Field, 'options' | 'showIf'>, values: any): boolean => {
  if (field.options?.hidden) {
    return false;
  }

  return !(field.showIf && !evaluateFieldCondition(field.showIf, values));
};

export const evaluateFieldCondition = (condition: FieldCondition, values: any): boolean => {
  if ('and' in condition) {
    return condition.and.every(c => evaluateFieldCondition(c, values));
  }
  if ('or' in condition) {
    return condition.or.some(c => evaluateFieldCondition(c, values));
  }
  if ('not' in condition) {
    return !evaluateFieldCondition(condition.not, values);
  }

  const { field, operator, value } = condition;
  const fieldValue = getIn(values, field);

  switch (operator) {
    case 'eq':
      return fieldValue === value;
    case 'neq':
      return fieldValue !== value;
    case 'gt':
      return fieldValue > value;
    case 'gte':
      return fieldValue >= value;
    case 'lt':
      return fieldValue < value;
    case 'lte':
      return fieldValue <= value;
    case 'in':
      return Array.isArray(value) && value.includes(fieldValue);
    case 'notIn':
      return Array.isArray(value) && !value.includes(fieldValue);
    case 'empty':
      return fieldValue == null || fieldValue === '' || (Array.isArray(fieldValue) && fieldValue.length === 0);
    case 'notEmpty':
      return fieldValue != null && fieldValue !== '' && !(Array.isArray(fieldValue) && fieldValue.length === 0);
    default:
      return true;
  }
};
